import React, { Component } from 'react'
import {BrowserRouter, Route, Switch} from 'react-router-dom'

import DashboardApp from './DashboardApp'
import PostApp from './contents/PostApp'
import PageApp from './contents/PageApp'
import NoticeApp from './contents/NoticeApp'
import TemplateApp from './contents/TemplateApp'
import KeywordApp from './contents/KeywordApp'
import ContentSettingApp from './contents/ContentSettingApp'
import CategoryApp from './CategoryApp'
import CommentSettingApp from './comments/CommentSettingApp'
import DesignSettingApp from './DesignSettingApp'
import BlogMenuApp from './BlogMenuApp'
import MobileSkinSetting from './MobileSkinSettingApp'
import SidebarApp from './SidebarApp'
import Sidebar from '../components/side/Sidebar'
import LinkApp from "./LinkApp"
import SkinAddApp from "./SkinAddApp"
import BlogSettingApp from './BlogSettingApp'
import BlogDataSettingApp from './BlogDataSettingApp'
import TeamBlogApp from './TeamBlogApp'
import SkinListApp from "./SkinListApp";
import PluginsApp from "./PluginsApp"
import CommentApp from "./comments/CommentApp";
import CommentTrashApp from "./comments/CommentTrashApp";
import GuestBookCommentApp from "./comments/GuestBookCommentApp";
import GuestBookCommentTrashApp from "./comments/GuestBookCommentTrashApp";
import KeyShortcutApp from './KeyShortcutApp';
import HistoryChangeListener from "../components/HistoryChangeListener";
import SkinArchiveListApp from "./SkinArchiveListApp";
import AuthorizeChecker from "../components/AuthorizeChecker";
import PhotoEditor from '../components/PhotoEditor';
import NotFoundPage from '../components/NotFoundPage';
import StatisticsBlogApp from "./statistics/StatisticsBlogApp";
import StatisticsReferrerApp from "./statistics/StatisticsReferrerApp";
import RevenueApp from "./revenue/RevenueApp";
import ManageAdsenseApp from "./revenue/ManageAdsenseApp";
import ManageAdfitApp from "./revenue/ManageAdfitApp";

import {addPrefix, getManageHome} from '../utils/UriUtil'
import {connect} from "react-redux";
import { setAdfitInfo, setAdsenseInfo } from "../actions/revenue";
import {jsonResponseHandler} from "../utils/FetchHelper";
import {TISTORY} from "../constants/Service";

@connect(state => ({
	revenue: state.revenue,
}), dispatch => ({
	setRevenueAdsenseInfo(info) {
		dispatch(setAdsenseInfo(info))
	},
	setRevenueAdfitInfo(info) {
		dispatch(setAdfitInfo(info))
	},
	dispatch
}))
class App extends Component {
	render() {
		const { revenue } = this.props;
		const link = getManageHome();

		return (
			<BrowserRouter basename={link}>
				<HistoryChangeListener>
					<KeyShortcutApp/>
					<Sidebar />
					<AuthorizeChecker>
						<Switch>
							<Route exact={true} path="/" component={DashboardApp} />
							<Route path="/posts" component={PostApp} />
							<Route path="/pages" component={PageApp} />
							<Route path="/category" component={CategoryApp} />
							<Route path="/notices" component={NoticeApp} />
							<Route path="/templates" component={TemplateApp} />
							<Route path="/keywords" component={KeywordApp} />
							<Route path="/setting/contents" component={ContentSettingApp} />

							<Route path="/comments" exact={true} strict={false} component={CommentApp}/>
							<Route path="/comments/trash" exact={true} strict={false} component={CommentTrashApp}/>
							<Route path="/guestbook" exact={true} strict={false} component={GuestBookCommentApp}/>
							<Route path="/guestbook/trash" exact={true} strict={false} component={GuestBookCommentTrashApp}/>
							<Route path="/setting/comments" component={CommentSettingApp} />

							<Route path="/statistics/blog" component={StatisticsBlogApp} />
							<Route path="/statistics/referrer" component={StatisticsReferrerApp} />

							<Route path="/revenue/adfit" component={revenue.tester ? ManageAdfitApp : NotFoundPage}/>
							<Route path="/revenue/adsense" component={revenue.tester ? ManageAdsenseApp : NotFoundPage}/>
							<Route path="/revenue" component={revenue.tester ? RevenueApp : NotFoundPage}/>

							<Route path="/design/menu" component={BlogMenuApp} />
							<Route path="/design/mobile" component={MobileSkinSetting} />
							<Route path="/design/sidebar" component={SidebarApp} />
							<Route path="/design/setting" component={DesignSettingApp} />
							<Route path="/design/skin" exact={true} component={SkinListApp} />
							<Route path="/design/skin/edit" exact={true} component={SkinListApp} />
							<Route path="/design/skin/add" component={SkinAddApp} />
							<Route path="/design/skin/archive" component={SkinArchiveListApp} />

							<Route path="/plugins" component={PluginsApp} />

							<Route path="/link/my" component={LinkApp} />

							<Route path="/setting/blog" exact={true} component={BlogSettingApp} />
							<Route path="/setting/blog/data" component={BlogDataSettingApp} />
							<Route path="/teamblog" component={TeamBlogApp} />
							<Route component={NotFoundPage} />
						</Switch>
					</AuthorizeChecker>
					<div id="photosContainer" className="photos_container">
						<PhotoEditor />
					</div>
				</HistoryChangeListener>
			</BrowserRouter>
		)
	}
}

export default App
